"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProgramModal = require("./ProgramModal");
Object.keys(_ProgramModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProgramModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProgramModal[key];
    }
  });
});
var _ProgramModalMobile = require("./ProgramModalMobile");
Object.keys(_ProgramModalMobile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProgramModalMobile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProgramModalMobile[key];
    }
  });
});